import React, { useEffect, useState } from 'react';
import './typingAni.css';

export default function TypingAnimation({ texts, handleSpan, seConStyle }) {
    const [currentText, setCurrentText] = useState('');
    const [currentTextIndex, setCurrentTextIndex] = useState(0);
    const [currentCharIndex, setCurrentCharIndex] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);

    useEffect(() => {
        function handleTextChange() {
            if (!isDeleting && currentCharIndex < texts[currentTextIndex].length) {
                setCurrentText(currentText + texts[currentTextIndex].charAt(currentCharIndex));
                setCurrentCharIndex(currentCharIndex + 1);
            } else if (isDeleting && currentCharIndex > 0) {
                setCurrentText(currentText.substring(0, currentCharIndex - 1));
                setCurrentCharIndex(currentCharIndex - 1);
            } else if (!isDeleting && currentCharIndex === texts[currentTextIndex].length) {
                setTimeout(() => setIsDeleting(true), 500); // Wait before starting to delete
            } else if (isDeleting && currentCharIndex === 0) {
                setIsDeleting(false);
                setCurrentTextIndex((currentTextIndex + 1) % texts.length);
            }
        }

        const timeout = setTimeout(handleTextChange, isDeleting ? 50 : 50); // Adjust speed for deleting and typing

        return () => clearTimeout(timeout);
    }, [currentCharIndex, currentText, currentTextIndex, isDeleting, texts]);

    return (
        <div style={seConStyle} className='ani-search-container' onClick={handleSpan}>
            {<span className='ani-search-input'>{currentText}</span>}
            <input type='text' className='invisible-input' readOnly />
        </div>
    );
}
